import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux'; // @ts-expect-error Could not find a declaration file for module

import { getLessonDisplayCategories } from '../../../selectors/categorySelectors';
import SkeletonThumbnail from './SkeletonThumbnail';
import ThumbnailOverlayed from './ThumbnailOverlayed';
import { useLesson, useLessonProgressTime } from '../../../features/lessons';
import { FormattedMessage } from '../../I18n';
import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import { LessonCardTimeReadout } from '../LessonCardTimeReadout';
import { useAssetStatus } from '../../../features/userProgress';
import { CardMenuIcon } from '../../../features/cardMenu';

const LessonThumbnailOverlayed = ({
  lessonId,
  isGhost,
  language,
  headerIcons = /*#__PURE__*/_jsx(CardMenuIcon, {
    language: language,
    lessonId: lessonId,
    use: "on-dark"
  })
}) => {
  const {
    lesson
  } = useLesson(lessonId, language);
  const {
    status
  } = useAssetStatus({
    id: lessonId,
    type: 'LESSON'
  });
  const completed = status === FILTER_CONSTS.STATUSES.COMPLETED;
  const categories = useSelector(state => getLessonDisplayCategories(state, {
    lessonId: `${lessonId}`
  }));
  const {
    remainingTime,
    totalTime
  } = useLessonProgressTime(lessonId);

  if (!lesson) {
    return /*#__PURE__*/_jsx(SkeletonThumbnail, {});
  }

  const {
    lessonType,
    previewThumbnailRectangleUrl
  } = lesson;
  return /*#__PURE__*/_jsx(ThumbnailOverlayed, {
    categories: categories,
    completed: completed,
    headerIcons: headerIcons,
    isGhost: isGhost,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    remainingTime: remainingTime || undefined,
    thumbnailFooter: !completed && /*#__PURE__*/_jsx(LessonCardTimeReadout, {
      lessonId: lessonId
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.resources.type.${lessonType && lessonType.length ? lessonType[0] : FILTER_CONSTS.LESSON_TYPES.LESSON}`
    }),
    totalTime: totalTime
  });
};

export default LessonThumbnailOverlayed;